import { useEffect, useRef } from "react";
import * as THREE from 'three';
// import { useLoader } from "@react-three/fiber";
import { positions } from "./cube.data";
// import CubeLoader from "./CubeLoader";

const xRotate = Math.PI / 35;
const yRotate = Math.PI / 4;

const CubeComponent = ({ actionImage, playerImage }) => {
    const innerCubeRef = useRef();
    const outerCubeRef = useRef();
    const cornerEdgesRef = useRef();
  
    useEffect(() => {
      // Set initial rotation for cubes and corner edges
      if (innerCubeRef.current) {
        innerCubeRef.current.rotation.set(xRotate, yRotate, 0);
      }
      if (outerCubeRef.current) {
        outerCubeRef.current.rotation.set(xRotate, yRotate, 0);
      }
      if (cornerEdgesRef.current) {
        cornerEdgesRef.current.rotation.set(xRotate, yRotate, 0);
      }
    }, []);
  
    // Define corner edges geometry
    const CornerEdges = () => {
      const cornerEdgesGeometry = new THREE.BufferGeometry();
      cornerEdgesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
  
      return (
        <lineSegments ref={cornerEdgesRef}>
          <bufferGeometry attach="geometry" {...cornerEdgesGeometry} />
          <lineBasicMaterial attach="material" color={0xDBB42C} linewidth={3} />
        </lineSegments>
      );
    };
  
    return (
      <>
        {/* Inner Cube */}
        <mesh ref={innerCubeRef}>
          <boxGeometry args={[2, 2, 2]} />
  
          {/* Use attach for materials to correspond to each face */}
          <meshBasicMaterial attach="material-0" color={0xa495ff} />
          <meshBasicMaterial attach="material-1" map={playerImage} side={THREE.DoubleSide} />
          <meshBasicMaterial attach="material-2" color={0xa495ff} />
          <meshBasicMaterial attach="material-3" color={0xa495ff} />
          <meshBasicMaterial attach="material-4" map={actionImage} side={THREE.DoubleSide} />
          <meshBasicMaterial attach="material-5" color={0xa495ff} />
        </mesh>
  
        {/* Outer Cube */}
        <mesh ref={outerCubeRef}>
          <boxGeometry args={[2.4, 2.4, 2.4]} />
          <meshBasicMaterial color={0xa495ff} transparent opacity={0.2} />
        </mesh>
  
        {/* Corner Edges */}
        <mesh ref={cornerEdgesRef}>
          <CornerEdges />
        </mesh>
      </>
    );
};

export default CubeComponent;